export default "__VITE_ASSET__DOf1elmZ__"